import { render, staticRenderFns } from "./ArtworkPreviewZoomTooltip.vue?vue&type=template&id=867680b2"
import script from "./ArtworkPreviewZoomTooltip.vue?vue&type=script&lang=js"
export * from "./ArtworkPreviewZoomTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports